import React from 'react';
import { Box, Tabs, Tab, Typography, Snackbar, Alert } from '@mui/material';
import { COLORS_ADMIN_PAGE } from '../conf/constants';
import { TRANSACTION_HISTORY_MANAGEMENT_CONSTANTS } from './constants/transactionHistoryManagement';
import { useErrorHandler } from '../utils/useErrorHandler';
import { useTransactionHistory } from './hooks/useTransactionHistory';
import TransactionHistoryTable from './components/TransactionHistoryTable';
import ReportTable from './components/ReportTab';

const TransactionHistoryManagement: React.FC = () => {
  const { snackbar, handleSnackbarClose } = useErrorHandler();
  
  const {
    transactions,
    municipalities,
    loading,
    searchTerm,
    setSearchTerm,
    currentPage,
    totalTransactions,
    transactionsPerPage,
    selectedTransactionTypes,
    handlePageChange,
    handleTransactionTypeFilter,
    onTransactionsPerPageChange, 
  } = useTransactionHistory();

  const [tabValue, setTabValue] = React.useState(0);
  const [reportSearchTerm, setReportSearchTerm] = React.useState('');

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      bgcolor: COLORS_ADMIN_PAGE.BACKGROUND, 
      height: TRANSACTION_HISTORY_MANAGEMENT_CONSTANTS.CONTAINER_HEIGHT,
      overflow: 'hidden'
    }}>
      {/* Tabs */}
      <Tabs 
        value={tabValue} 
        onChange={handleTabChange}
        sx={{ 
          borderBottom: 1, 
          borderColor: 'divider',
          flexShrink: 0
        }}
      >
        <Tab label={TRANSACTION_HISTORY_MANAGEMENT_CONSTANTS.TABS.TRANSACTIONS} />
        <Tab label={TRANSACTION_HISTORY_MANAGEMENT_CONSTANTS.TABS.REPORT} />
      </Tabs>

      {/* Tab Panels */}
      {tabValue === 0 && (
        <Box sx={{ 
          flex: 1, 
          bgcolor: COLORS_ADMIN_PAGE.WHITE,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          minHeight: 0 // Important: allows flex item to shrink
        }}>
          <TransactionHistoryTable
            transactions={transactions}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            currentPage={currentPage}
            totalTransactions={totalTransactions}
            transactionsPerPage={transactionsPerPage}
            onPageChange={handlePageChange}
            loading={loading}
            selectedTransactionTypes={selectedTransactionTypes}
            onTransactionTypeFilter={handleTransactionTypeFilter}
            onTransactionsPerPageChange={onTransactionsPerPageChange}
          />
        </Box>
      )}
      {tabValue === 1 && (
        <Box sx={{ 
          flex: 1, 
          bgcolor: COLORS_ADMIN_PAGE.WHITE,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          minHeight: 0
        }}>
          <ReportTable
            municipalities={municipalities}
            searchTerm={reportSearchTerm}
            onSearchChange={setReportSearchTerm}
          />
        </Box>
      )}

      {/* Snackbar for errors */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={TRANSACTION_HISTORY_MANAGEMENT_CONSTANTS.SNACKBAR_DURATION}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TransactionHistoryManagement;